import React from "react";
import styled from "styled-components";
import 정답 from "../assets/정답.png";
import 오답1 from "../assets/오답1.png";
import 오답2 from "../assets/오답2.png";
import 오답3 from "../assets/오답3.png";

import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, NumberText, Question } from "./styled";
import useSelect from "../hooks/useSelect";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage1 = ({ setScreen }: Props) => {
  const ANSWER = 2;
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        다음 중 올바른
        <br />
        태극기를 고르시오.
      </Question>

      <AnswerContainer>
        <Wrapper onClick={() => onClickItem(1)} $incorrect={select === 1}>
          <NumberText>⓵</NumberText>
          <Image src={오답1} alt="select" />
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $correct={!!select}>
          <NumberText>⓶</NumberText>
          <Image src={정답} alt="select" />
        </Wrapper>
        <Wrapper onClick={() => onClickItem(3)} $incorrect={select === 3}>
          <NumberText>⓷</NumberText>
          <Image src={오답2} alt="select" />

          {select === 3 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(4)} $incorrect={select === 4}>
          <NumberText>⓸</NumberText>
          <Image src={오답3} alt="select" />

          {select === 4 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={2}
          setScreen={setScreen}
        />
      )}
    </Container>
  );
};

export default Stage1;

const AnswerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 10px;

  margin-top: 10px;
`;

const Image = styled.img`
  width: 100%;
`;

const Wrapper = styled.div<{ $correct?: boolean; $incorrect?: boolean }>`
  position: relative;
  cursor: pointer;

  border: ${({ $correct }) => $correct && "3px solid lightgreen"};
  border: ${({ $incorrect }) => $incorrect && "3px solid red"};

  border-radius: 10px;

  padding: 10px;
`;
